(() => {
  if (customElements.get('na-plant-landing')) return;
  customElements.define('na-plant-landing', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const filters = this.querySelector('.np-filters');
      const cards = [...this.querySelectorAll('[data-category]')];
      if (filters && cards.length) filters.hidden = false;
      const filter = (value) => {
        let count = 0;
        cards.forEach(card => { card.hidden = value !== 'all' && card.dataset.category !== value; if (!card.hidden) count++; });
        filters?.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === value)));
        const status = this.querySelector('[data-filter-status]');
        if (status) status.textContent = `${count} opciones para consultar.`;
      };
      this.addEventListener('click', event => {
        const control = event.target.closest('[data-filter], [data-choose]');
        if (control) filter(control.dataset.filter || control.dataset.choose);
        else if (event.target.closest('a')?.getAttribute('href') === `#np-products-${this.id.replace('na-plant-', '')}`) filter('all');
      }, { signal });
      this.videos = [...this.querySelectorAll('video')];
      this.videos.forEach(video => video.addEventListener('play', () => this.videos.forEach(other => { if (other !== video) other.pause(); }), { signal }));
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.videos.forEach(video => video.pause()); }, { signal });
    }
    disconnectedCallback() {
      this.videos?.forEach(video => video.pause());
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
